
const TaskSideBar = ({isOpen}) =>{
    return(
        <div className={`  transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'} w-96 mt-14 flex-right  text-white   w-full h-screen max-h-dvh bg-primary p-3 `}>
                    
                </div>
    );
}
export default TaskSideBar;